import { projectIqTokens } from "apps/project-iq/theme/projectIqTokens";
import {
  IRagDimension,
  RaidCategory,
  RagStatus,
  RaidSeverity,
} from "apps/project-iq/components/WorkspacePlan/WorkspacePlan.types";

export const MAX_VISIBLE_AVATARS = 4;

export const AVATAR_COLORS = [
  projectIqTokens.teal,
  projectIqTokens.violet,
  projectIqTokens.blue,
  projectIqTokens.amber,
  projectIqTokens.green,
];

export {
  MILESTONE_STATUS_LABELS,
  DELIVERABLE_STATUS_LABELS,
  RAID_STATUS_LABELS,
} from "apps/project-iq/constants/planStatusLabels";

export const RAID_CATEGORY_LABELS: Record<RaidCategory, string> = {
  risk: "Risks",
  action: "Actions",
  issue: "Issues",
  decision: "Decisions",
};

export const RAID_SEVERITY_LABELS: Record<RaidSeverity, string> = {
  high: "High",
  medium: "Medium",
  low: "Low",
};

export const RAG_STATUS_COLOR: Record<RagStatus, string> = {
  green: projectIqTokens.green,
  amber: projectIqTokens.amber,
  red: projectIqTokens.rust,
};

export const DEFAULT_RAG_DIMENSIONS: IRagDimension[] = [
  { id: "overall", label: "Overall", status: "green", statusText: "On track" },
  { id: "budget", label: "Budget", status: "green", statusText: "On track" },
  {
    id: "schedule",
    label: "Schedule",
    status: "green",
    statusText: "On track",
  },
  { id: "scope", label: "Scope", status: "green", statusText: "On track" },
];
